"use client";

import { useRouter } from "next/navigation";
import { formatMoney } from "@/lib/format";
import { ORDER_TYPE } from "@/lib/orderType";
import { useCart } from "@/store/hooks";
import CartItemRow from "./CartItemRow";

const FREE_DELIVERY_THRESHOLD = 50;

export default function GroceryCartDrawer({ onClose }) {
  const router = useRouter();
  const { cart, count, loading, cartError } = useCart(ORDER_TYPE.GROCERY);
  const items = cart?.items || [];
  const currency = cart?.currency_code || "cad";
  const subtotal = Number(cart?.subtotal || 0);
  const amountAway = Math.max(FREE_DELIVERY_THRESHOLD - subtotal, 0);
  const progress = Math.min((subtotal / FREE_DELIVERY_THRESHOLD) * 100, 100);

  return (
    <aside className="asian-bucket-cart-drawer-main-wrapper asian-bucket-grocery-cart-drawer-main-wrapper">
      <div className="asian-bucket-cart-drawer-header-main-wrapper">
        <img src="/assets/icons/basket.svg" alt="" />
        <div>
          <h2>Your Grocery Basket</h2>
          <p>
            {count} {count === 1 ? "item" : "items"}
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close grocery basket"
        >
          ×
        </button>
      </div>

      <div className="asian-bucket-cart-drawer-items-main-wrapper">
        {loading && !items.length ? (
          <div className="asian-bucket-cart-drawer-empty-main-wrapper">
            Loading basket...
          </div>
        ) : items.length ? (
          items.map((item) => (
            <CartItemRow
              key={item.id}
              item={item}
              orderType={ORDER_TYPE.GROCERY}
            />
          ))
        ) : (
          <div className="asian-bucket-cart-drawer-empty-main-wrapper">
            <img src="/assets/images/empty-image.png" alt="empty image" />
            <h3>Your Grocery Basket is empty</h3>
            <p>Add grocery products and they will appear here.</p>
          </div>
        )}
      </div>

      {cartError && (
        <p className="asian-bucket-cart-drawer-error">{cartError}</p>
      )}

      {!!items.length && (
        <div className="asian-bucket-grocery-delivery-card-main-wrapper">
          <div className="asian-bucket-grocery-free-delivery-row">
            <img src="/assets/icons/truck.svg" alt="" />
            <strong>
              {amountAway > 0
                ? `${formatMoney(amountAway, currency)} away from FREE next-day delivery`
                : "You qualify for FREE next-day delivery"}
            </strong>
          </div>

          <div className="asian-bucket-grocery-delivery-progress-main-wrapper">
            <span style={{ width: `${progress}%` }} />
          </div>

          <div className="asian-bucket-grocery-order-time-row">
            <img src="/assets/icons/clock.svg" alt="" />
            <span>Order by 5 PM for next-day delivery.</span>
          </div>

          <div className="asian-bucket-grocery-delivery-options-main-wrapper">
            <div>
              <img src="/assets/icons/home.svg" alt="" />
              <p>
                <strong>Pickup:</strong> no minimum · order by 9 PM
              </p>
            </div>
            <div>
              <img src="/assets/icons/basket.svg" alt="" />
              <p>
                <strong>Uber Eats / DoorDash:</strong> no minimum · order by 9
                PM
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="asian-bucket-cart-drawer-footer-main-wrapper">
        <div className="asian-bucket-cart-drawer-subtotal-main-wrapper">
          <span>Subtotal</span>
          <strong>{formatMoney(subtotal, currency)}</strong>
        </div>

        <button
          type="button"
          className="asian-bucket-cart-drawer-checkout-button asian-bucket-grocery-checkout-button"
          disabled={!items.length}
          onClick={() => {
            onClose();
            router.push("/checkout/grocery");
          }}
        >
          Checkout <span>→</span>
        </button>
      </div>
    </aside>
  );
}
